export enum PlatformDocumentUploadType {
  CV = 'cv',
  COVER_LETTER = 'cover-letter',
  CERTIFICATE = 'certificate',
  OTHER = 'other',
}
